import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export type AvatarPerson = {
  firstName: string;
  lastName: string;
  userId?: string;
};

const AVATAR_PALETTE: { background: string; color: string }[] = [
  { background: '#FBE3EA', color: '#B8466A' },
  { background: '#D9EEF4', color: '#005A97' },
  { background: '#DDF5EC', color: '#025740' },
  { background: '#EFE5FF', color: '#5B17B5' },
  { background: '#FBE9E3', color: '#B8462A' },
  { background: '#E3E7F6', color: '#25357A' },
  { background: '#FFF2CC', color: '#7A5A00' },
  { background: '#DCF5FD', color: '#03799E' },
];

export const avatarColors = (seed: string) => {
  let hash = 0;
  for (const char of seed) {
    hash = (hash * 31 + char.charCodeAt(0)) | 0;
  }
  return AVATAR_PALETTE[Math.abs(hash) % AVATAR_PALETTE.length];
};

export const personInitials = (person: AvatarPerson): string => {
  const first = person.firstName.trim()[0] ?? '';
  const last = person.lastName.trim()[0] ?? '';
  return (first + last).toUpperCase() || '?';
};

export const personFullName = (person: AvatarPerson): string =>
  [person.firstName, person.lastName].filter(Boolean).join(' ');

export const personFromFullName = (fullName?: string): AvatarPerson | undefined => {
  const parts = (fullName ?? '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
    return undefined;
  }
  return { firstName: parts[0], lastName: parts.slice(1).join(' ') };
};

export const personFromUserOption = (
  option?: SelectSearchOptionModel,
): AvatarPerson | undefined => {
  const parts = (option?.label ?? '').trim().split(/\s+/).filter(Boolean);
  if (!option || parts.length === 0) {
    return undefined;
  }
  return { firstName: parts.slice(1).join(' '), lastName: parts[0], userId: option.value };
};
